import React from 'react';
import classnames from 'classnames';
import styles from './dataVendors.module.scss';
import { Redirect } from 'react-router';
import { Spinner } from 'react-bootstrap';
import { useQuery } from 'react-query';
import restFactory from 'v2/utils/restFactory';
import { DataVendor, DjangoListResponse } from 'v2/models';
import NoDataVendors from 'v2/common/DRM/ListPages/NoDataVendors';

const DataVendorsHome = () => {
  const {
    data: { results: dataVendorsData, count: dataVendorsCount = 0 } = {},
    isFetching,
  } = useQuery(
    ['DataVendors_fetchingDataVendors'],
    async () => {
      return await restFactory.get<DjangoListResponse<DataVendor>>(
        `/dj/api/v1/data_vendor/`,
        {
          page: 1,
        }
      );
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  );

  const renderHomeContainer = () => {
    if (isFetching) {
      return (
        <div className="loadingIndicatorContainer">
          <Spinner animation="border" />
        </div>
      );
    } else if (!dataVendorsCount || !dataVendorsData?.length) {
      return <NoDataVendors />;
    } else {
      return <Redirect to="/data-providers/1" />;
    }
  };

  return (
    <div className={classnames('container-xl', styles.dataVendorsContainer)}>
      <div
        className={classnames(
          'd-flex justify-content-between position-relative z-index-1',
          styles.titleBackground
        )}
        style={{ height: '122px' }}
      >
        <div className="container-xl d-flex justify-content-between position-relative fix-bg-images">
          <div className="d-flex align-items-center text-truncate">
            <h1 className="m-0 text-truncate pr-1" role="heading">
              Data Providers
            </h1>
          </div>
        </div>
      </div>
      {renderHomeContainer()}
    </div>
  );
};

export default DataVendorsHome;
